// components/TwitterEmbed.tsx
import React, { useEffect } from "react";

export default function TwitterEmbed(props: any){

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="flex justify-center my-5">
      <blockquote className="twitter-tweet">
        <a href={'https://twitter.com/'+props.author+'/status/'+props.tweetId}>.</a>
      </blockquote>
    </div>
  );
};